<script setup>
import { SOCIAL_SHARE_IMAGE, usePageHead } from '@composables/use-page-head'
import { computed, watch } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { useSearchStore } from '@state/stores/search'
import Layout from '@layouts/main-layout'
import SearchBar from '@components/search/search-bar'
import recentSearchService from '@services/search/recent-search-service'

const RECENT_SEARCH_OPTIONS = ['artist', 'genre', 'mix', 'show']

const route = useRoute()
const router = useRouter()
const searchStore = useSearchStore()

const searchKeyword = computed(() => searchStore.keyword)

onBeforeRouteLeave(to => {
    const itemId = to.params.id || to.params.slug
    if (RECENT_SEARCH_OPTIONS.includes(to.name) && itemId && !to.query.back) {
        recentSearchService.addToRecent({
            id: `${to.name}-${itemId}`,
            type: to.name,
            itemId,
        })
    }
    return true
})

watch(searchKeyword, keyword => {
    if (keyword) {
        router.push({
            name: route.name.includes('search/results') ? route.name : 'search/results/top',
            params: { keyword: keyword.replace(/ /g, '_') },
        })
    } else {
        router.push({ name: 'search' })
    }
})

usePageHead({
    title: 'Search',
    description: 'Search FRISKY for mixes, shows, artists, and genres.',
    image: SOCIAL_SHARE_IMAGE,
})
</script>

<template>
    <Layout :hide-mobile-menu-bar="true">
        <!-- Mobile-only search bar positioned as header (hidden on desktop) -->
        <div class="mobile-search-bar">
            <SearchBar />
        </div>
        <BaseContent class="search-area">
            <router-view v-slot="{ Component }">
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <component :is="Component" />
                </transition>
            </router-view>
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.search-area {
    min-height: calc(100vh - #{$size-music-player} - #{$size-search-bar-height});

    @include desktop {
        min-height: calc(100vh - #{$size-music-player});
    }
}

.mobile-search-bar {
    position: sticky;
    top: 0;
    z-index: $layer-dropdown-z-index;

    @include desktop {
        display: none;
    }
}
</style>
